module.exports = __webpack_public_path__ + "static/media/tastemakers-campus-4.dc662011.png";